<div class="bv-modal-report">
  <h2 class="bv-modal-report__title">
    @if (data?.payload) {
      {{data.payload.fullname}}
    }
    @if (!data?.payload) {
      {{'IND.FULL_REPO' | translate}}
    }
  </h2>
  <p class="bv-modal-report__description">{{'IND.ASK_TYPE_DOC' | translate}}</p>

  <div class="bv-modal-report__options">
    <mat-checkbox color="primary" [formControl]="FormGroup?.controls.authorities">
    {{'IND.AUTHORITY' | translate}}</mat-checkbox>
    <mat-checkbox color="primary" [formControl]="FormGroup?.controls.stock">
    {{'IND.STOCK' | translate}}</mat-checkbox>
    <mat-checkbox color="primary" [formControl]="FormGroup?.controls.powers">
    {{'IND.POWER' | translate}}</mat-checkbox>
    <mat-checkbox color="primary" [formControl]="FormGroup?.controls.powers_old">
    {{'INDV.POA_NO_VIGENTES' | translate}}</mat-checkbox>
  </div>

  <div class="bv-modal-report__actions">
    <button class="bv-btn bv-btn--secondary" mat-dialog-close (click)="close()">{{'BUTTONS.CANCEL' | translate}}</button>
    <button class="bv-btn bv-btn--primary" (click)="getReport()"
      [disabled]="(!FormGroup?.value.authorities && !FormGroup?.value.stock && !FormGroup?.value.powers && !FormGroup?.value.powers_old)"
    cdkFocusInitial>
      <mat-icon>file_download</mat-icon>
      {{'BUTTONS.DOWNLOAD' | translate}}
    </button>
  </div>
</div>
